import { LinkProps } from 'next/link';
import { useRouter } from 'next/router';
import React, { ReactNode, useCallback } from 'react';

export interface ButtonLinkProps {
  href: LinkProps['href'];
  onClick?: () => void;
  className?: string;
  children: ReactNode;
  dataTestId?: string;
}

const ButtonLink: React.FC<ButtonLinkProps> = ({ href, onClick, className, children, dataTestId }) => {
  const router = useRouter();

  const handleClick = useCallback(() => {
    onClick?.();
    router.push(href);
  }, [href, onClick, router]);

  return (
    <button type='button' className={className} data-testid={dataTestId} onClick={handleClick}>
      {children}
    </button>
  );
};

export default ButtonLink;
